import type { PoolOverviewData } from '@/types/pool';
import { formatCurrency } from '@/utils/misc';
import { OverviewSection } from './OverviewSection';
import { StatCard } from './StatCard';

type InvestorOverviewProps = {
  overviewStats: Partial<PoolOverviewData> | null;
  loading?: boolean;
};

export default function InvestorOverview({ overviewStats, loading = false }: InvestorOverviewProps) {
  const fundedPools = overviewStats?.funded_pools ?? 0;
  const fundedCountText = fundedPools === 1 ? 'Funded Pool' : 'Funded Pools';

  return (
    <OverviewSection title="Overview">
      {/* Overview Cards - Responsive Grid */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
        <StatCard
          header="Total Invested"
          mainText={formatCurrency(overviewStats?.total_invested)}
          secondaryText={`${fundedPools} ${fundedCountText}`}
          loading={loading}
        />
        <StatCard
          header="Funds In Escrow"
          mainText={formatCurrency(overviewStats?.invested_in_escrow)}
          secondaryText={`${overviewStats?.pending_pools ?? 0} Pending Pools`}
          loading={loading}
        />
        <StatCard
          header="My Active Pools"
          mainText={formatCurrency(overviewStats?.invested_offers)}
          secondaryText={`${overviewStats?.offers_or_counter_offers ?? 0} Pools Awaiting Borrower Action`}
          loading={loading}
        />
      </div>
    </OverviewSection>
  );
}
